import { useEffect, useState } from 'react'
import {
  View,
  Text,
  TextInput,
  ActivityIndicator
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import Card from '../../shared/card/Card'
import CustomButton from '../../shared/button/Button'
import { Formik } from 'formik'
import * as yup from 'yup'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import { usePersonalStore } from '../../../stores/personalInfo'
import Toast from 'react-native-toast-message'
import { CheckBox } from 'react-native-elements'

const InInformationForm = ({ navigation, route }: any) => {

    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params
    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postinonline, getinstates, instates } = useFormsStore()
    const intialValues = params?.values || {
        indiana_country_of_residence: '',
        pricipal_employment: '',
        changeseffective: "",
        residentofIndiana: '',
        spousenotclaimingexemption: '',
        dependent: '',
        additionalExemptions: '',
        eachqualifyingdependent: '',
        firsttimeclaiming: "",
        adoptedclaiming: "",
        additionalstatewithholding: "",
        additionalcountywithholding: "",
        indianacountrycode: "",
        principalemploymentcode: ""
    }
    const w4schema = () => {
        const baseSchema = {
            indiana_country_of_residence: yup.string().required('Indiana County of Residence is a required field'),
            pricipal_employment: yup.string().required('Principal Employment is a required field'),
            changeseffective: yup.string().required('Changes to the counties is a required field'),
            residentofIndiana: yup.string()
                .matches(/^(|0|1)$/, "Enter '1' or '0'")
                .nullable(),
            spousenotclaimingexemption: yup.string()
                .matches(/^1$/, "Enter '1' or leave it empty")
                .nullable(),
            dependent: yup.string().nullable(),
            additionalExemptions: yup.mixed().nullable(),
            eachqualifyingdependent: yup.string().nullable(),
            firsttimeclaiming: yup.string().nullable(),
            adoptedclaiming: yup.string().nullable(),
            additionalstatewithholding: yup.string().nullable(),
            additionalcountywithholding: yup.string().nullable()
        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()

    const checkboxData = [
        { id: 1, title: 'You are 65 or older', isChecked: false },
        { id: 2, title: 'or blind', isChecked: false },
        { id: 3, title: 'spouse is 65 or older', isChecked: false },
        { id: 4, title: 'or blind', isChecked: false },
    ];
    const [checkboxes, setCheckboxes] = useState(params?.checkedids ?
        checkboxData.map(checkbox => ({ ...checkbox, isChecked: params.checkedids.includes(checkbox.id.toString()) }))
        : checkboxData);

    const toggleCheckbox = (id: any) => {
        const newCheckboxes = checkboxes.map(checkbox =>
            checkbox.id === id ? { ...checkbox, isChecked: !checkbox.isChecked } : checkbox
        );
        setCheckboxes(newCheckboxes);
    };

    const resetCheckbox = () => {
        const newcheckboxes = checkboxes.map(checkbox => ({ ...checkbox, isChecked: false }));
        setCheckboxes(newcheckboxes);
    }

    const getCheckedIds = () => {
        return checkboxes
            .filter(checkbox => checkbox.isChecked)
            .map(checkbox => checkbox.id.toString());
    };

    const options1 = [
        { key: 1, value: 'No' },
        { key: 2, value: 'Yes' }
    ]

    const handleResetValues = (props: any) => {
        resetCheckbox()
        props.setFieldValue('spousenotclaimingexemption', '')
        props.setFieldValue('dependent', '')
        props.setFieldValue('additionalExemptions', '')
        props.setFieldValue('eachqualifyingdependent', '')
        props.setFieldValue('firsttimeclaiming', '')
        props.setFieldValue('adoptedclaiming', '')
    }




    useEffect(() => {
        getinstates()
    }, [])

    if (loading)
        return <ActivityIndicator />



    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'IN Witholding Taxation'}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    enableReinitialize={true}
                    onSubmit={async (values, actions) => {
                        const checkedids = getCheckedIds()
                        const data = {
                            entityId: personalstore?.personalData?.entityId,
                            essUserKey:
                                intializeStore?.initializeData?.userkey,
                            essObKey: essUserOnBoardingKey,
                            essUserOnBoardingFormKey:
                                essUserOnBoardingFormKey,
                            completeOnline: mode === 'upload' ? false : true,
                            indianaCountyOfResidence: values?.indianacountrycode,
                            principalEmployment: values?.principalemploymentcode,
                            changesEffective: values?.changeseffective ? true : false,
                            residentOfIndiana: Number(values?.residentofIndiana),
                            claimExemption: Number(values?.spousenotclaimingexemption),
                            dependentExemption: Number(values?.dependent),
                            additionalExemptions: checkedids,
                            noofBoxesChecked: checkedids?.length,
                            total: Number(values?.residentofIndiana) + Number(values?.spousenotclaimingexemption) + Number(values?.dependent) + checkedids?.length,
                            eachQualifyingDependent: Number(values?.eachqualifyingdependent),
                            firstTimeClaiming: Number(values?.firsttimeclaiming),
                            adoptedClaiming: Number(values?.adoptedclaiming),
                            additionalStateWithholding: Number(values?.additionalstatewithholding),
                            additionalCountyWithholding: Number(values?.additionalcountywithholding),
                            IndianaCountyOfResidenceText: values?.indiana_country_of_residence,
                            PrincipalEmploymentText: values?.pricipal_employment
                        }
                        const response = await postinonline(data)
                        if (response?.success) {

                            if (mode === 'online') {
                                navigation.navigate('InInformationOnline', {
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values,
                                    mode,
                                    checkedids
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        }
                        else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }
                    }}
                >
                    {(props) => (
                        <Card>


                            {instates?.data && (
                                <>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '65%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Indiana County of Residence as of January 1 *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>

                                            <SelectKeyValue
                                                title="Indiana County of Residence as of January 1 "
                                                options={instates?.data}
                                                selectedOption={props.values.indiana_country_of_residence}

                                                onSelect={(option: any) => {
                                                    const country = instates?.data.find((item: any) => item.cid == option);
                                                    props.setFieldValue('indiana_country_of_residence', country?.countyName || "")
                                                    props.setFieldValue('indianacountrycode', country?.countyCode || "")

                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.indiana_country_of_residence &&
                                                props.errors.indiana_country_of_residence && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.indiana_country_of_residence as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>


                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '65%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Indiana County of Principal Employment as of January 1 *'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>


                                            <SelectKeyValue
                                                title="Indiana County of Principal Employment as of January 1 "
                                                options={instates?.data}
                                                selectedOption={props.values.pricipal_employment}
                                                onSelect={(option: any) => {
                                                    const country = instates?.data.find((item: any) => item.cid == option);
                                                    props.setFieldValue('pricipal_employment', country?.countyName || "")
                                                    props.setFieldValue('principalemploymentcode', country?.countyCode || "")

                                                }}
                                                textColor="primary"
                                            />
                                            {props.touched.pricipal_employment &&
                                                props.errors.pricipal_employment && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.pricipal_employment as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                </>
                            )}

                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '65%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {'Are the changes to the counties effective for the next calendar year *'}
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <SelectKeyValue
                                        title="Are the changes to the counties effective for the next calendar year "
                                        options={options1}
                                        selectedOption={
                                            props.values.changeseffective === 1 ? 'Yes' :
                                                props.values.changeseffective === 0 ? 'No' : ''
                                        }
                                        onSelect={(option: any) => {
                                            props.setFieldValue('changeseffective', option - 1)
                                        }}
                                        textColor="primary"
                                    />
                                    {props.touched.changeseffective &&
                                        props.errors.changeseffective && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.changeseffective as string}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '65%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {'You are entitled to one exemption. If you wish to claim the exemption, enter “1”\nNonresident aliens must skip lines 2 through 8. See instructions'}
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.residentofIndiana}
                                        keyboardType='numeric'
                                        onChangeText={(text) => {
                                            if (text === '' || /^\d+$/.test(text)) {
                                                props.handleChange('residentofIndiana')(text)
                                            }
                                            if (text !== '1') {
                                                handleResetValues(props)
                                            }
                                        }}
                                    />
                                    {props.touched.residentofIndiana &&
                                        props.errors.residentofIndiana && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.residentofIndiana as string}
                                            </Text>
                                        )}
                                </View>
                            </View>

                            {Number(props.values.residentofIndiana) == 1 &&
                                <>

                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '65%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'Are you married, and is your spouse not claiming their exemption? If yes, enter 1'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.spousenotclaimingexemption}
                                                keyboardType='numeric'
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('spousenotclaimingexemption')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.spousenotclaimingexemption &&
                                                props.errors.spousenotclaimingexemption && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.spousenotclaimingexemption as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>

                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '65%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'How many exemptions are you claiming for your dependents?'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.dependent}
                                                keyboardType='numeric'
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('dependent')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.dependent &&
                                                props.errors.dependent && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.dependent as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>



                                    <View
                                        style={[
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    ' Additional exemptions (Check block in front of applicable statement.)  '
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ flexDirection: "row", flexWrap: "wrap", overflow: 'hidden' }}>
                                            {checkboxes.map(checkbox => (
                                                <CheckBox
                                                    key={checkbox.id}
                                                    title={checkbox.title}
                                                    checked={checkbox.isChecked}
                                                    onPress={() => {

                                                        toggleCheckbox(checkbox.id)
                                                        props.setFieldValue("additionalExemptions", getCheckedIds())

                                                    }

                                                    }
                                                    checkedColor="#0B495C"
                                                    uncheckedColor="#0B495C"
                                                    containerStyle={{ backgroundColor: 'transparent', borderWidth: 0 }}
                                                    titleProps={{
                                                        style: {
                                                            fontWeight: "normal",
                                                            color: "#0B495C"
                                                        }
                                                    }}
                                                />
                                            ))}
                                        </View>
                                        {props.touched.additionalExemptions &&
                                            props.errors.additionalExemptions && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.additionalExemptions as string}
                                                </Text>
                                            )}
                                    </View>


                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '65%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'For each qualifying dependent, how many additional exemptions are you claiming?'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.eachqualifyingdependent}
                                                keyboardType='numeric'
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('eachqualifyingdependent')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.eachqualifyingdependent &&
                                                props.errors.eachqualifyingdependent && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.eachqualifyingdependent as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>


                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '65%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'How many additional exemptions are you claiming for each qualifying dependent being claimed for the first time?'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.firsttimeclaiming}
                                                keyboardType='numeric'
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('firsttimeclaiming')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.firsttimeclaiming &&
                                                props.errors.firsttimeclaiming && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.firsttimeclaiming as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '65%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {'How many additional exemptions are you claiming for each adopted qualifying dependent?'}
                                            </Text>
                                        </View>
                                        <View style={{ width: '28%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.adoptedclaiming}
                                                keyboardType='numeric'
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('adoptedclaiming')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.adoptedclaiming &&
                                                props.errors.adoptedclaiming && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.adoptedclaiming as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>

                                </>}

                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '65%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {'Enter the amount of additional state withholding you want withheld each pay period?'}
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.additionalstatewithholding}
                                        keyboardType='numeric'
                                        onChangeText={(text) => {
                                            if (text === '' || /^\d+$/.test(text)) {
                                                props.handleChange('additionalstatewithholding')(text)
                                            }
                                        }}
                                    />
                                    {props.touched.additionalstatewithholding &&
                                        props.errors.additionalstatewithholding && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.additionalstatewithholding as string}
                                            </Text>
                                        )}
                                </View>
                            </View>
                            <View
                                style={[
                                    globalStyles.hDirection,
                                    globalStyles.hBetweenItems,
                                    globalStyles.mb2
                                ]}
                            >
                                <View style={{ justifyContent: 'center', width: '65%' }}>
                                    <Text
                                        style={[
                                            globalStyles.inputLabel,
                                            globalStyles.inputLabelLarge,
                                            globalStyles.inputLabelPrimary
                                        ]}
                                    >
                                        {'Enter the amount of additional county withholding you want withheld each pay period?'}
                                    </Text>
                                </View>
                                <View style={{ width: '28%', overflow: 'hidden' }}>
                                    <TextInput
                                        style={[globalStyles.input, globalStyles.inputLight]}
                                        value={props.values.additionalcountywithholding}
                                        keyboardType='numeric'
                                        onChangeText={(text) => {
                                            if (text === '' || /^\d+$/.test(text)) {
                                                props.handleChange('additionalcountywithholding')(text)
                                            }
                                        }}
                                    />
                                    {props.touched.additionalcountywithholding &&
                                        props.errors.additionalcountywithholding && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.additionalcountywithholding as string}
                                            </Text>
                                        )}
                                </View>
                            </View>
                            {loading ? (
                                <ActivityIndicator />
                            ) : (
                                <View style={{ margin: 10 }}>
                                    <CustomButton
                                        text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                        onPress={props.handleSubmit}
                                    />
                                </View>
                            )}


                        </Card>)}
                </Formik>
            </View>
        </KeyboardAwareScrollView>
    )
}
export default InInformationForm
